<template>
  <v-menu offset-y>
    <!-- status menu activator -->
    <template v-slot:activator="{ on, attrs }">
      <span class="ml-10" color="white" elevation="0" v-bind="attrs" v-on="on">
        <v-icon x-small :color="active.icon_color">
          {{ active.icon }}
        </v-icon>
        <span v-show="$vuetify.breakpoint.mdAndUp"> {{ active.status }} </span>
        <v-icon>mdi-menu-down</v-icon>
      </span>
    </template>
    <!-- status menu item -->
    <v-list>
      <v-list-item-group v-model="status">
        <v-list-item
          v-for="(item, key) in items"
          :key="key"
          :value="item.status"
          @click="active = item"
          dense
        >
          <v-list-item-icon class="mx-0">
            <v-icon x-small :color="item.icon_color">
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content v-text="item.status" class="ma-0 pa-0">
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "AppHeaderMenuStatus",

  data: () => ({
    active: {
      icon_color: "green",
      icon: "mdi-circle",
      status: "Online",
    },
    items: [
      {
        icon_color: "yellow darken-2",
        icon: "mdi-circle",
        status: "In call",
      },
      {
        icon_color: "blue",
        icon: "mdi-circle",
        status: "After call work",
      },
      {
        icon_color: "green",
        icon: "mdi-circle",
        status: "Available",
      },
      {
        icon_color: "green",
        icon: "mdi-circle",
        status: "Online",
      },
      {
        icon_color: "red",
        icon: "mdi-circle",
        status: "Do not disturb",
      },
      {
        icon_color: "red",
        icon: "mdi-circle",
        status: "On break",
      },
      {
        icon_color: "red",
        icon: "mdi-circle",
        status: "End of shift",
      },
      {
        icon_color: "gray",
        icon: "mdi-circle",
        status: "Offline",
      },
      {
        icon_color: "gray",
        icon: "mdi-circle",
        status: "Away",
      },
    ],
  }),

  watch: {
    status(val) {
      if (val) {
        this.active = this.items.find((e) => e.status == val);
      }
    },
  },

  computed: {
    status: {
      get() {
        return this.$store.getters["profile/status"];
      },
      set(val) {
        this.$store.dispatch("profile/updateStatus", val);
      },
    },
    filteredItems() {
      return this.items.filter;
    },
  },

  mounted() {
    if (this.status) {
      if (this.status == "Offline")
        this.$store.dispatch("profile/updateStatus", "Online");
      else this.active = this.items.find((e) => e.status == this.status);
    } else this.$store.dispatch("profile/updateStatus", "Online");
  },
};
</script>
